import { useProductSelectionStoreActions } from '../../product-selection.store';
import { useAlphabeticalIndexSearchQuery } from './useAlphabeticalIndexSearchQuery';

type UseSelectAlphabeticalLetterParams = {
  onSelected: () => void;
};

export const useSelectAlphabeticalLetter = (params?: UseSelectAlphabeticalLetterParams) => {
  const { isNumericSearchQuery, alphabeticalIndexSearchQuery } = useAlphabeticalIndexSearchQuery();
  const { setAlphabeticalIndexSearchQuery, clearAlphabeticalIndexSearchQuery, clearSelectedAnalogDrug } =
    useProductSelectionStoreActions();

  const selectLetter = (letter: string) => {
    const isSelected = letter === alphabeticalIndexSearchQuery;

    if (isSelected) {
      clearAlphabeticalIndexSearchQuery();
    } else {
      setAlphabeticalIndexSearchQuery(letter);
      clearSelectedAnalogDrug();
    }

    params?.onSelected();
  };

  return {
    isNumericSearchQuery,
    alphabeticalIndexSearchQuery,
    selectLetter,
  };
};
